// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"102":"8d9ec51a","112":"8d9ec51a","732":"8d9ec51a"}[chunkId] + ".chunk.css";
};